<script>
	import { slide } from "svelte/transition";

	import { createEventDispatcher } from "svelte";
	import { uiText } from "../lib/uiText.js";
	export let lang;

	const dispatch = createEventDispatcher();
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
</script>

<div
	transition:slide
	class="grid m-[10px] p-[15px] obelisk bg-blue-100 bg-opacity-40 place-content-center place-self-center place-items-center text-center max-w-prose"
>
	<h3 class="text-teal">{ui.game.skippable_riddle_title}</h3>
	<p class="mb-2">{ui.game.skippable_riddle_description}</p>

	<button
		class="justify-center place-self-center outline"
		on:click={() => dispatch("skipSkippable", "skipSkippable")}
	>
		<i class="fa-solid fa-ban" data-position="left" />
		{ui.game.skippable_riddle_skip}
	</button>
</div>

<style>
	p {
		text-wrap: balance;
	}
</style>
